var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.945,
    height: 51.945,
    viewBox: "0 0 51.945 51.945",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "target",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1192",
    "data-name": "Group 1192",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1191",
    "data-name": "Group 1191",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3379",
    "data-name": "Path 3379",
    d: "M27.069,24.927c-.009-.009-.011-.021-.02-.03l-8.685-8.685V10.756a1.521,1.521,0,0,0-.446-1.076L8.787.447a1.522,1.522,0,0,0-2.6,1.076V6.089H1.522a1.522,1.522,0,0,0-1.076,2.6l9.232,9.232a1.521,1.521,0,0,0,1.076.446h5.457L24.9,27.05c.009.009.021.011.03.02a1.515,1.515,0,0,0,2.142-2.142Z",
    transform: "translate(0 -0.001)",
    fill: "#7dbaab"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1194",
    "data-name": "Group 1194",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1193",
    "data-name": "Group 1193",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3380",
    "data-name": "Path 3380",
    d: "M25.975,0A25.745,25.745,0,0,0,15.084,2.54l4.668,4.668A19.833,19.833,0,1,1,7.21,19.752L2.541,15.083A25.748,25.748,0,0,0,0,25.974,25.973,25.973,0,1,0,25.975,0Z",
    transform: "translate(-0.003 -0.002)",
    fill: "#7dbaab"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1196",
    "data-name": "Group 1196",
    transform: "translate(12.277 12.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1195",
    "data-name": "Group 1195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3381",
    "data-name": "Path 3381",
    d: "M134.7,121a13.536,13.536,0,0,0-4.566.841v1.834l3.518,3.518a7.492,7.492,0,0,1,1.047-.106,7.609,7.609,0,1,1-7.609,7.609,7.489,7.489,0,0,1,.106-1.047l-3.518-3.518h-1.834A13.536,13.536,0,0,0,121,134.7,13.7,13.7,0,1,0,134.7,121Z",
    transform: "translate(-121.002 -121.001)",
    fill: "#7dbaab"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.0163e8df7b3498a9787f5967ea850fe3.svg";
export { ForwardRef as ReactComponent };